import * as types from '../actions/actionTypes';
import initialState from "./initialState";

export function listPostedSchedulesReducer(
  state = initialState.listPostedSchedules, action
  ) {
  switch(action.type) {
    case types.FETCH_LIST_POSTED_SCHEDULES_SUCCESS:
      return action.listPostedSchedules;
    default:
      return state;
  }
}

export function postedSchedulesReducer(
  state = initialState.postedSchedules, action
  ) {
  switch(action.type) {
    case types.FETCH_POSTED_SCHEDULES_SUCCESS:
      return action.postedSchedules;
    default:
      return state;
  }
}
export function postedSchedulesJSONReducer(
  state = {}, action
  ) {
  switch(action.type) {
    case types.FETCH_POSTED_SCHEDULES_JSON_SUCCESS:
      return action.postedSchedules;
    default:
      return state;
  }
}

export function listPreviousPostingsReducer(
  state = initialState.listPreviousPostings, action
  ) {
  switch(action.type) {
    case types.FETCH_LIST_PREVIOUS_POSTINGS_SUCCESS:
      return action.listPreviousPostings;
    default:
      return state;
  }
}

export function resourceCollectionInformationReducer(
  state = initialState.resourceCollectionInformation, action
  ) {
  switch(action.type) {
    case types.FETCH_RESOURCE_COLLECTION_INFORMATION:
      return action.resourceCollectionInformation;
    default:
      return state;
  }
}

export function createPostedScheduleReducer(
  state = initialState.postingScheduleObject, action
) {
  switch(action.type) {
    case types.ADD_POSTED_SCHEDULE_SUCCESS:
      return {
        ...state,
        status: true,
        message: action.response
      };
    case types.ADD_POSTED_SCHEDULE_FAILURE:
        return {
          ...state,
          status: false,
          message: action.error
        };
    default:
        return '';
  }
}

export function postedScheduleParametersReducer(
  state = initialState.postedScheduleParameters, action
) {
  switch (action.type) {
    case types.EDIT_POSTED_SCHEDULE_PARAMETERS_SUCCESS:
      return action.parameters;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/postedScheduleReducer.js